import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, onBeforeMount, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { Ref, PropType } from 'vue'
import {
  getAlarmLevelDistribution,
  getAlarmTypeDistribution
} from '@/api/gucangSales/dataBoard'
import dayjs, { Dayjs } from 'dayjs'
import { getMonthDays } from '@/utils/timeFormat'
import { colors } from '../dataConfig'


const __default__ = { name: 'AlarmDistribution' }

interface ItemCommonType {
  name: string
  quantity: number,
  total: number,
  prop: string
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '异动类型分布'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  // 情况类型 默认是异动类型 1 异动等级2
  distributionType: {
    type: String as PropType<string>,
    default: '1'
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const monthValue = ref<Dayjs>(dayjs())
const levelNames = ['一级异动', '二级异动', '三级异动']
watch(() => props.formState, (val) => {
  getData()
})
watch(() => props.distributionType, (val) => {
  getData()
})
const getData = () => {
  const queryForm = {
    ...props.formState,
    distributionType: props.distributionType
  }
  spinning.value = true
  if (props.distributionType === '1') {
    getAlarmTypeDistribution(queryForm)
      .then((res: any) => {
        const data = res.data?.alarmTypeList as unknown as ItemCommonType[]
        if (!data || data.length === 0) {
          showECharts.value = false
          initChart([])
        } else {
          showECharts.value = true
          data.forEach((item) => {
            item.percent = (item?.total ? Number((((item.quantity ?? 0) / item.total) * 100).toFixed(2)) : 0)
            return item
          })
          initChart(data)
        }
      }).finally(() => {
        spinning.value = false
      })
  } else {
    getAlarmLevelDistribution(queryForm)
      .then((res: any) => {
        const data = res.data?.alarmLevelList as unknown as ItemCommonType[]
        if (!data || data.length === 0) {
          showECharts.value = false
          initChart([])
        } else {
          const transData: ItemCommonType[] = []
          levelNames.forEach((name) => {
            data.forEach((item) => {
              /// 这里过滤下一些脏数据 例如名称是空的
              if (item && item.name) {
                if (name === item.name) {
                  item.percent = (item?.total ? Number((((item.quantity ?? 0) / item.total) * 100).toFixed(2)) : 0)
                  transData.push(item)
                }
              }
            })
          })
          showECharts.value = true
          initChart(transData)
        }
      }).finally(() => {
        spinning.value = false
      })
  }
}
const pieColors = colors.filter((item) => item !== '#EE6666')
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
const initChart = (data: ItemCommonType[]) => {
  setOptions({
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: 'left',
      bottom: 'center',
      top: 'middle',
      icon: 'circle',
      // left: 'right',
      // align: 'left', // 文字位置
      padding: [0, 30],
      formatter: (val) => {
        const quality = data.find((item) => item.name === val)?.quantity
        const arr = [
          '{b|' + val + '}',
          '{c|' + quality + '}'
        ]
        return arr.join(' ')
      },
      textStyle: {
        align: 'right',
        rich: {
          b: {
            color: '#6E7B91',
            fontSize: '12px'
          },
          c: {
            fontWeight: 'bold',
            color: '#6E7B91',
            fontSize: '16px'
          }
        }
      }
    },
    series: [
      {
        type: 'pie',
        radius: '76%',
        labelLayout: {
          hideOverlap: false
        },
        bottom: 15,
        right: 150,
        minAngle: 1,
        data: data.map((item, index) => ({
          value: item.quantity,
          name: item.name,
          itemStyle: {
            color: item.name === '一级异动' || item.name === '流失异动' ? '#EE6666' : (index < pieColors.length ? pieColors[index] : undefined) // 设置特定区域的颜色
          },
          prop: item.prop,
          label: {
            show: item.percent && item.percent > 10,
            position: 'inside',
            color: '#fff',
            /// 如果需要设置字体 可以添加 textStyle: {color:'', fontsize: ''}
            formatter: (val) => {
              return val.data?.name + '\n' + val.data?.prop
            },
            emphasis: {
              show: true // 鼠标悬浮时显示标签
            }
          }
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  })
}
onBeforeMount(() => getData())

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: spinning.value,
    delay: 200
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        ref_key: "chartRef",
        ref: chartRef,
        class: "home-echarts-content"
      }, null, 512), [
        [_vShow, showECharts.value]
      ]),
      (!showECharts.value)
        ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
            key: 0,
            type: "nothing"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})